<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >

 <!-- <v-spacer></v-spacer> -->
        <material-card
            :color="app.color"
          >
          <v-layout wrap slot="header">
            <v-flex sm6 xs12>
              <span class="title">{{form.content.template.name}}</span><br>
              <span class="body-1">{{form.content.parent_object.details['name']}}</span>
            </v-flex>
          </v-layout>

            <v-container  fluid>
              <v-layout row>
                <v-container fluid>
                <v-tooltip right="" dark="">
                  <template #activator='data'>
                    <v-btn medium text icon color="transparent">
                      <v-icon @click="goBack()" v-on="data.on" :color="app.color">mdi-backspace</v-icon>
                    </v-btn>                  
                  </template>
                  <span>Terug</span>
                </v-tooltip>          
                
                <v-spacer></v-spacer>
                </v-container>
              </v-layout>
            </v-container>          

          <v-layout >
            <v-flex md6 xs12>
              <document-show-log logType="form" :reference="form.content.reference"></document-show-log>
            </v-flex>
            <v-flex md6 xs12>
              <document-render-form></document-render-form>
            </v-flex>
          </v-layout>

        </material-card>
      </v-flex>
    </v-layout>
    
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["app", "form"])
  },
  methods: {
    goBack() {
      this.$router.push("/formulieren");
    }
  },
  created() {
    this.$store.dispatch("checkAuth");
  }
};
</script>